import { Model, Result } from '@gameonly/core';
import Bar1DComponent, { Bar1DLegend } from '../results/Bar1DComponent';
import BarSingle1DComponent, {
  BarSingle1DLegend,
} from '../results/BarSingle1DComponent';
import Pie1DComponent, { Pie1DLegend } from '../results/Pie1DComponent';
import TreemapComponent, { TreemapLegend } from '../results/TreemapComponent';
import { ActionsPage } from './pages/ActionsPage';
import { Table } from './PdfTables';

export const PdfResultDispatch = ({
  result,
  model,
  compact = false,
}: {
  result: Result;
  model?: Model;
  compact?: boolean;
}) => {
  switch (result.type) {
    case 'nav':
    case 'globalScore':
    case 'scoreCard':
      return null;
    case 'treemap':
      return <TreemapComponent result={result} />;
    case 'text':
      return <ActionsPage result={result} modelName={model?.name || ''} />;
    case 'pie1D':
      return <Pie1DComponent result={result} model={model} compact={compact} />;
    case 'barSingle1D':
      return (
        <BarSingle1DComponent result={result} model={model} compact={compact} />
      );
    case 'table':
      return <Table result={result} model={model} />;
    case 'bar1D':
      return <Bar1DComponent result={result} model={model} compact={compact} />;
    case 'barStacked1D':
      return <>TODO barStacked1D</>;
    case 'barStacked2D':
      return <>TODO barStacked2D</>;
  }
  return null;
};

export const PdfLegendDispatch = ({
  result,
  model,
  compact = false,
  color,
}: {
  result: Result;
  model?: Model;
  compact?: boolean;
  color?: string;
}) => {
  switch (result.type) {
    case 'pie1D':
      return (
        <Pie1DLegend
          result={result}
          model={model}
          forPDF={true}
          compact={compact}
          color={color}
        />
      );
    case 'barSingle1D':
      return (
        <BarSingle1DLegend
          result={result}
          model={model}
          forPDF={true}
          compact={compact}
          color={color}
        />
      );
    case 'treemap':
      return (
        <TreemapLegend
          result={result}
          compact={compact}
          color={color}
        />
      );
    case 'bar1D':
      return (
        <Bar1DLegend
          result={result}
          model={model}
          forPDF={true}
          compact={compact}
          color={color}
        />
      );

    case 'barStacked1D':
      return <>TODO barStacked1D</>;
    case 'barStacked2D':
      return <>TODO barStacked2D</>;
  }
  return null;
};
